import React from "react";
const API_BASE = "https://api.ainfotech.com.np";

export default function BlogCard({ item, onEdit, onDelete, openForm }) {
  const imgSrc = item.cover_image ? `${API_BASE}${item.cover_image}` : null;

  return (
    <article className="blog-card">
      <div className="blog-card__thumb">
        {imgSrc ? (
          <img src={imgSrc} alt={item.title} loading="lazy" />
        ) : (
          <div className="blog-card__thumb--empty">No Image</div>
        )}
      </div>

      <div className="blog-card__body">
        <div className="blog-card__tags">
          {item.tag_primary && <span className="chip chip--blue">{item.tag_primary}</span>}
          {item.tag_secondary && <span className="chip chip--green">{item.tag_secondary}</span>}
        </div>

        <h3 className="blog-card__title">{item.title}</h3>
        <p className="blog-card__excerpt">{item.excerpt}</p>

        <div className="blog-card__actions">
          <button
            className="btn btn--ghost"
            onClick={() => {
              onEdit(item);
              openForm();
            }}
            aria-label="Edit post"
            title="Edit"
          >
            <span className="i i-edit" aria-hidden="true" /> Edit
          </button>
          <button
            className="btn btn--danger"
            onClick={() => onDelete(item.id)}
            aria-label="Delete post"
            title="Delete"
          >
            <span className="i i-trash" aria-hidden="true" /> Delete
          </button>
        </div>
      </div>
    </article>
  );
}
